<template>
  <div class="authorCenter">
    <Header></Header>
    <div class="authorBox flexible authorBox-big">
      <sidebar></sidebar>
      <div class="writewrap flex">
        <Bread></Bread>
        <div class="right author-right">
          <div v-if="messagelist.length > 0" class="chapter-title flexible aItem-cenmessageListter">
                <span v-for="(message, index) in messageList" :class="tabIndex == message.type?'text-theme':'text-65656E'" class="f-csp font-MT f20" @click="tabIndex = message.type">
                    {{message.name}}
                    <i class="line" v-if="tabIndex == message.type"></i>
                </span>
          </div>
            <div class="messageList">
                <div class="msgItem flexible" v-for="msg in messagelist">
                    <div class="title-icon">
                        <img src="../../assets/ic_logo.png"/>
                    </div>
                    <div class="msg-con font-MT">
                        <div class="msg-con-top text-muted">
                            <span class="f16">{{msg.title?msg.title:'Black Gemstone'}}</span>
                            <span class="msg-con-time f14">{{msg.createTime}}</span>
                        </div>
                        <div class="msg-con-detail mt20 text-fff f16 mb20" v-html="msg.content">
<!--                            <a href='/#/authorManage/chapterList/1524639449810501634'>qqqqqqqqqqqqqqqq</a>-->
                            {{msg.content}}
                        </div>
                    </div>
                </div>
            </div>
          <div class="datanull" v-if="messagelist.length == 0">
            <img src="@/assets/author/no-data.png"/>
            <p>{{$lang('authorCenter.inbox.NoInbox')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {AuthorNotice,noticed} from 'apiurl/notice';
export default {
    data() {
        return {
            messageList: [
                // {name: 'All notifications', type: 0},
                {name: this.$lang('authorCenter.inbox.System'), type: 1},
                // {name: '回复', type: 2},
                // {name: '邀请', type: 3},
                // {name: '帮助反馈', type: 4},
            ],
            tabIndex: 1,
            params: {
                pageNo: 1,
                pageSize: 10,
                sort: 1
            },
            messagelist: [],
            busy: false,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.getbottom); // 滚动到底部，再加载的处理事件
        this.getAuthorNotice()
        this.getnoticed()
    },
    methods: {
        async getAuthorNotice () {
            let msg = await AuthorNotice(this.params)
            if (msg) {
                if (msg.success) {
                    if (msg.data.items.length > 0) {
                        this.messagelist = this.messagelist.concat(msg.data.items);
                        this.busy = msg.data.hasNextPage
                        this.params.pageNo = Number(msg.data.pageNum)
                    }
                }
            }
        },
        getnoticed () {
            noticed().then(res=>{})
        },
        getbottom() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            let clientHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;
            let numHeight = scrollTop + clientHeight;
            if (scrollHeight > clientHeight && numHeight > scrollHeight - 100) {
                if (this.busy) {
                    this.busy = false;
                    this.params.pageNo++;
                    this.getAuthorNotice()
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
  .chapter-title{
    height: 90px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 16px 16px 0 0;
    span{
      display: inline-block;
      height: 90px;
      line-height: 90px;
      margin-right: 30px;
      position: relative;
      i{
        display: block;
        width: 50px;
        height: 6px;
        background: #FF049B;
        position: absolute;
        border-radius: 3px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    span:first-child{
      margin-left: 51px;
    }
  }
  .messageList{
      width: 100%;
      padding-bottom: 50px;
      .msgItem{
          margin: 40px 50px 0 50px;
          border-bottom: 1px solid #575776;
          .title-icon{
              width: 40px;
              height: 40px;
              img{
                  width: 40px;
                  height: 40px;
              }
          }
          .msg-con{
              margin-left: 20px;
              margin-top: 10px;
              .msg-con-time{
                  margin-left: 40px;
              }
              .msg-con-detail{
                  /deep/a{
                      color: #7DB36C!important;
                  }
              }

          }
      }
  }
</style>
